import React from 'react'

export default function CheckboxArrow(props) {
	return (
	<svg className="checkbox-arrow__icon" xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
		<path d="M4.1806 8.61295L0.18025 4.78119C-0.0600834 4.55098 -0.0600834 4.17773 0.18025 3.9475L1.05059 3.11382C1.29092 2.88359 1.68062 2.88359 1.92096 3.11382L4.61578 5.69505L10.3878 0.166306C10.6281 -0.0638989 11.0178 -0.0638989 11.2582 0.166306L12.1285 0.999991C12.3688 1.2302 12.3688 1.60345 12.1285 1.83368L5.05097 8.61297C4.81061 8.84318 4.42093 8.84318 4.1806 8.61295Z" fill={props.color}/>
	</svg>
	)
}
